import { throttle } from "lodash";

if (!window.pingInit) window.pingInit = {};
window.pingInit.initBackToTopArrow = (context) => {
  const pageContainer = document.querySelector(".page-container");
  if (!context || !pageContainer) return;

  const manageButtonVisibility = throttle(() => {
    if (context.dataset?.template === "product") {
      if (window.innerWidth > 768) {
        if (window.scrollY > 0) {
          context.classList.add("visible");
        } else {
          context.classList.remove("visible");
        }
      } else {
        if (pageContainer.scrollTop > 0) {
          context.classList.add("visible");
        } else {
          context.classList.remove("visible");
        }
      }
    } else {
      if (window.scrollY > 0) {
        context.classList.add("visible");
      } else {
        context.classList.remove("visible");
      }
    }
  }, 300);
  manageButtonVisibility();
  window.addEventListener("scroll", manageButtonVisibility);
  if (context.dataset?.template === "product") {
    pageContainer.addEventListener("scroll", manageButtonVisibility);
  }

  context.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo(0, 0, "smooth");
    pageContainer.scrollTo(0, 0, "smooth");
  });
};

if (document.readyState != "loading") {
  [].forEach.call(
    document.querySelectorAll("button.top-arrow__wrapper"),
    (el) => {
      window.pingInit.initBackToTopArrow(el);
    }
  );
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(
      document.querySelectorAll("button.top-arrow__wrapper"),
      (el) => {
        window.pingInit.initBackToTopArrow(el);
      }
    );
  });
}
